module.exports = __webpack_public_path__ + "static/media/adsFree.2c55f378.svg";